import { TextField } from '@mui/material'
import intl from 'localization/components'

interface NameProps {
  messages: Record<string, string>
  props: {
    value?: string
    onChange: (value: string) => void
  }
}

const Name = ({ messages, props }: NameProps) => {
  const { value, onChange } = props

  function capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  return (
    <TextField
      size="small"
      style={{ width: '100%' }}
      value={capitalize(value ?? '')}
      label={messages[intl.generic('first-name')]}
      onChange={(event) => {
        return onChange(event.target.value)
      }}
    />
  )
}

export default Name
